import styled from 'styled-components/macro';
import { Image } from '@yme/atoms/image';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { promotionalBannerShadow } from '@yme/tokens/elevations';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { HeadingLevel4 } from '@yme/tokens/typography';
import { Z_INDEX } from '@yme/tokens/zindex';
import { AspectRatio } from '@yme/utils/constants';
import { getTextStyles } from '@yme/utils/styles';
export const BannerImageStyled = styled(Image) `
  width: 100%;

  ${ADAPTIVE.minWidth.desktop} {
    width: 92%;
  }

  img {
    aspect-ratio: ${AspectRatio.RectangleLevel3};
    object-fit: cover;
  }
`;
export const PromotionalBannerDescriptionStyled = styled(FlexWrapper) `
  padding: 24px;
  z-index: ${Z_INDEX.level2};
  background-color: ${colorCoreWhite1000};
  box-shadow: ${promotionalBannerShadow};

  width: 90%;
  margin-top: -32px;

  ${ADAPTIVE.minWidth.tablet} {
    width: 80%;
  }

  ${ADAPTIVE.minWidth.desktop} {
    position: absolute;
    margin: 0;
    padding: 32px;
    width: 432px;
    left: 0;
    top: 50%;
    transform: translate(0, -50%);
  }
`;
export const HeadingLevel4Styled = styled(HeadingLevel4) `
  ${getTextStyles('Play', 700, 14, 16)}

  ${ADAPTIVE.minWidth.desktop} {
    ${getTextStyles('Play', 700, 18, 24)}
  }
`;
